import { Card, Grid, Typography } from '@mui/material';
import styles from '../Information/Information.module.scss';
import CONSTANTS from '../../config/constants.json';

const RefundPolicy = () => {
  const email = `refunds@${CONSTANTS.DOMAIN_NAME}`;
  return (
    <>
      <div className={styles.Refundpolicy}>
        <Typography className={styles.typoGraphyHeading}>Refund Policy</Typography>
        <Card className={styles.cardContainer}>
          <div style={{padding:"24px"}}>
          <Grid>
            <Typography className={styles.heading}>Refund, Return & Cancellation Policy</Typography>
            <Grid>
              <Typography className={styles.content}>The donations can be refunded, returned or
                cancelled, if you send us an email, explaining the circumstances for your request,
                within 24 hours of your donation. Upon receipt of your request, it would take us up
                to 10 days to post to your credit card.You should send an email to<span className={styles.email}><a href={`mailto:${email}`} className={styles.email}>
                    {email}
                  </a></span>using your email address that is registered in temple website.</Typography>
            </Grid>
          </Grid>
          </div>
        </Card>
      </div>
    </>
  )
}
export default RefundPolicy;